/*
 * @Author: Kuiper
 * @Date: 2021-06-24 19:37:19
 */
import type { App } from 'vue'

import {
  Modal,
  Table,
  Menu,
  Input,
  Form,
  Card,
  Checkbox,
  Radio,
  Upload,
  Button,
  Switch,
  Row,
  Progress,
  List,
  Layout,
  Col,
  Tabs,
  Select,
  Icon,
  Dropdown,
  Tag,
  Avatar,
  Tooltip,
  Image,
  Divider,
  Anchor,
  Popconfirm,
  Popover,
  Spin,
  Pagination,
} from 'ant-design-vue'

import 'ant-design-vue/dist/antd.css'

export function setupAntd(app: App<Element>) {
  app
    .use(Form)
    .use(Input)
    .use(Modal)
    .use(Table)
    .use(Menu)
    .use(Card)
    .use(Checkbox)
    .use(Radio)
    .use(Upload)
    .use(Button)
    .use(Switch)
    .use(Row)
    .use(Progress)
    .use(List)
    .use(Layout)
    .use(Col)
    .use(Tabs)
    .use(Icon)
    .use(Select)
    .use(Dropdown)
    .use(Tag)
    .use(Avatar)
    .use(Tooltip)
    .use(Image)
    .use(Divider)
    .use(Anchor)
    .use(Popconfirm)
    .use(Popover)
    .use(Spin)
    .use(Pagination)
}
